import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=2f6e556a&scoped=true&"
import script from "./Legal.vue?vue&type=script&lang=ts&"
export * from "./Legal.vue?vue&type=script&lang=ts&"
import style0 from "./Legal.vue?vue&type=style&index=0&id=2f6e556a&lang=scss&scoped=true&"
import style1 from "./Legal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e556a",
  null
  
)

export default component.exports